import { portConstants } from '../../_constants';

export function ports(state = {}, action) {
    switch (action.type) {
        case portConstants.PORT_FETCHING:
            return {
                ...state,
                portFetching: true
            };
        case portConstants.PORT_FETCHED:
            return {
                ...state,
                portFetching: false
            };
        case portConstants.PORT_SUBMITTING:
            return {
                ...state,
                portSubmitting: true
            };
        case portConstants.PORT_SUBMITTED:
            return {
                ...state,
                portSubmitting: false
            };
        case portConstants.GET_PORTS:
            return {
                ...state,
                ports: action.ports
            };
        case portConstants.GET_PORT_BY_ID:
            return {
                ...state,
                port: action.port
            };
        case portConstants.GET_ACTIVE_PORTS:
            return {
                ...state,
                activePorts: action.activePorts,
            };
        case portConstants.GET_ACTIVE_PORTS_BRANCH_ORIGIN:
            return {
                ...state,
                originPorts: action.originPorts
            };
        case portConstants.GET_ACTIVE_PORTS_BRANCH_DESTINATION:
            return {
                ...state,
                destinationPorts: action.destinationPorts
            };
        case portConstants.BRANCH_WITH_PORTS:
            return {
                ...state,
                portsBranch: action.portsBranch
            }
        default:
            return state;
    }
}